// @flow
import {
  UPDATE_CART,
  UPDATE_CART_SUCCESS,
  TOGGLE_RESET_CART,
  RESET_CART,
  CLEAR_LAST_TRANSACTION,
  ADD_LAST_TRANSACTION,
  SAVE_CART,
  SAVE_CART_SUCCESS,
  FETCH_CART,
  FETCH_CART_SUCCESS,
  FETCH_CART_ERROR,
  SET_CART_ORDER_ID,
  THROTTLE_SAVE_CART,
  INITIATE_SAVE_CART,
  SET_TRANSACTION_VALUE,
  SAVE_CART_ERROR
} from "./types";
import type { Action } from "./types";
import type { CartData } from "./types";
import type { CartState, SaveTrigger } from '../reducers/cart';

export const updateCart = (cartData: CartData): Action => ({
  type: UPDATE_CART,
  payload: cartData
});

export const updateCartSuccess = (cart: CartData): Action => ({
  type: UPDATE_CART_SUCCESS,
  payload: cart
});

export const toggleResetCartDlg = (open: boolean, type?: 'ACTIVE_ORDER' | 'CART'): Action => ({
  type: TOGGLE_RESET_CART,
  payload: {open, type}
});

export const resetCart = (): Action => ({
  type: RESET_CART,
});

export const clearLastTransaction = (): Action => ({
  type: CLEAR_LAST_TRANSACTION,
});

export const addLastTransaction = (cartData: CartData): Action => ({
  type: ADD_LAST_TRANSACTION,
  payload: cartData
});

export const saveCart = (mobile: string, sessionId: string, trigger: SaveTrigger = 'CART', affiliateName:? string): Action => ({
  type: SAVE_CART,
  payload: {mobile, sessionId, trigger}
});

export const throttleSaveCart = (mobile: string, sessionId: string, trigger: SaveTrigger = 'PRODUCTS', affiliateName:? string): Action => ({
  type: THROTTLE_SAVE_CART,
  payload: {mobile, sessionId, trigger, affiliateName}
});

export const initiateSaveCart = (): Action => ({
  type: INITIATE_SAVE_CART,
});

export const saveCartSuccess = (cart: CartState): Action => ({
  type: SAVE_CART_SUCCESS,
  payload: cart
});

export const saveCartError = (error: Error): Action => ({
  type: SAVE_CART_ERROR,
  payload: error
});

export const fetchCart = (cart: CartState, mobile: string, sessionId: string, affiliateName:? string): Action => ({
  type: FETCH_CART,
  payload: {cart, mobile, sessionId, affiliateName}
});

export const fetchCartSuccess = (cart: CartState): Action => ({
  type: FETCH_CART_SUCCESS,
  payload: cart
});

export const fetchCartError = (error: Error): Action => ({
  type: FETCH_CART_ERROR,
  payload: error
});

export const setCartOrderId = (orderId: string): Action => ({
  type: SET_CART_ORDER_ID,
  payload: orderId
});

export const setTransactionValue = (amount: number): Action => ({
  type: SET_TRANSACTION_VALUE,
  payload: amount
});
